import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@Auth/useAuth";
import { Entity } from "@models/Entity";
import { billingClient } from "../clients/billingClient";
import { billingKeys } from "./billingKeys";

export function useSubscription() {
  const { baseUser } = useAuth();
  const orgId = baseUser?.organization_id;

  return useQuery({
    queryKey: billingKeys.detail(orgId!),
    queryFn: () => billingClient.getSubscription(orgId!),
    enabled: !!orgId,
    meta: { entity: Entity.BILLING },
  });
}
